/* eslint-disable react/prop-types */
/* eslint-disable eqeqeq */
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/styles";
import { CardHeader, Divider, Grid, Button } from "@material-ui/core";
import ViewListIcon from "@material-ui/icons/ViewList";
import CircularProgress from "@material-ui/core/CircularProgress";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import { Edit } from "@material-ui/icons";
import checkMark from "../../../../assets/images/check-mark-icon.png";
import crossMark from "../../../../assets/images/cross-mark-icon.png";
import { IsEmpty } from "../../../../utils/helper";

const useStyles = () => ({
  card: {
    display: "flex",
    flexDirection: "column",
    boxShadow:
      "0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 2px 15px 0 rgba(0, 0, 0, 0.19)",
    borderRadius: 10,
    height: "100%",
  },

  itemCard: {
    display: "flex",
    flexDirection: "column",
    boxShadow:
      "0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 2px 15px 0 rgba(0, 0, 0, 0.19)",
    borderRadius: 10,
    width: "98%",
    marginTop: 10,
    overflow: "visible",
    backgroundColor: "#f2f2f2",
    cursor: "pointer",
    marginBottom: 10,
  },
  title: {
    color: "#3f51b5",
    display: "flex",
    fontSize: 20,
  },
  itemTitle: {
    color: "#3f51b5",
    fontSize: 15,
    marginRight: 5,
    textAlign: "left",
  },
  itemSubTitle: {
    fontSize: 15,
    whiteSpace: "nowrap",
  },
  titleIcon: {
    marginRight: 20,
    fontSize: 28,
  },
  titleDivider: {
    width: "90%",
    backgroundColor: "#3f51b5",
    opacity: "0.5",
    marginLeft: 20,
  },
  itemCardTitleDivider: {
    width: "100%",
    backgroundColor: "grey",
    opacity: "0.5",
  },
  cardContent: {
    padding: 0,
    width: "90%",
    marginLeft: 20,
    overflow: "auto",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  itemCardContent: {
    padding: 0,
    width: "90%",
    marginLeft: 20,
    marginTop: 10,
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "baseline",
  },

  quantityItem: {
    display: "flex",
    width: "10%",
    justifyContent: "space-between",
  },

  listItem: {
    outline: "none",
    cursor: "pointer",
    paddingTop: 5,
    paddingBottom: 5,
    paddingLeft: 10,
    paddingRight: 10,
  },
  listItemContainer: {
    display: "flex",
    // justifyContent: "space-between",
    width: "100%",
  },
  listItemKey: {
    fontSize: 14,
    textAlign: "left",
    fontWeight: 600,
    width: "75%",
  },

  listItemRejectedKey: {
    fontSize: 14,
    textAlign: "left",
    fontWeight: 600,
    color: "grey",
    width: "75%",
  },
  listAddonItemKey: {
    fontSize: 12,
    textAlign: "left",

    width: "75%",
  },
  listAddonItemRejectedKey: {
    fontSize: 12,
    textAlign: "left",
    color: "grey",
    width: "75%",
  },
  listItemValue: {
    fontSize: 13,
    textAlign: "left",
    width: "25%",
  },
  halfWidthRight: {
    width: "50%",
    textAlign: "right",
  },
  subListItemContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
  totalAmount: {
    fontSize: 14,
    display: "flex",
    justifyContent: "flex-end",
    width: "100%",
    marginRight: 10,
  },
  barcodeImage: {
    display: "flex",
    width: "100%",
    justifyContent: "end",
  },
  circularProgressStyle: {
    marginTop: 10,
  },
  itemCardContentTitle: {
    fontSize: 14,
    fontWeight: 700,
    textDecoration: "underline",
  },
  itemCardItemTitle: {
    fontSize: 14,
    fontWeight: 700,
    textAlign: "left",
    marginTop: 10,
    marginBottom: 10,
  },
  listItemActive: {
    backgroundColor: "#ffdddd !important",
  },
});

function ImageButton(props) {
  return (
    <button style={{ marginRight: 2, padding: 0 }} onClick={props.onClick}>
      <img
        style={{ width: 30, height: 30 }}
        src={props.imageSrc}
        alt={props.altText}
      />
    </button>
  );
}

class SalesTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOrder: props.selectedOrder,
      isRejected: false,
    };
  }

  isRejected = (value) => {
    this.setState({
      isRejected: value,
    });
  };

  componentDidUpdate(prevProps) {
    if (this.props.selectedOrder !== prevProps.selectedOrder) {
      this.setState({ selectedOrder: this.props.selectedOrder });
    }
  }

  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <Card className={classes.card}>
          <CardHeader
            style={{ paddingBottom: 10 }}
            title={
              <span className={classes.title}>
                <ViewListIcon className={classes.titleIcon} />
                <b>Detail</b>
              </span>
            }
          />
          <Divider className={classes.titleDivider} />
          <CardContent className={classes.cardContent}>
            {this.props.values.salesDataLoading ? (
              <div className={classes.circularProgressStyle}>
                <CircularProgress />
              </div>
            ) : (
              <Fragment>
                {this.state.selectedOrder.length > 0 && (
                  <Fragment>
                    <Card key={2} className={classes.itemCard}>
                      <CardHeader
                        style={{
                          backgroundColor: "#d9d8d8",

                          padding: "10px 16px",
                        }}
                        title={
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              width: "100%",
                            }}
                          >
                            Shipping Detail{" "}
                            <Button>
                              <Edit
                                onClick={() => {
                                  // alert(
                                  //   "ABCDef" +
                                  //     this.state.selectedOrder[0]
                                  //       .shippingAddresses.customerName
                                  // );

                                  this.props.toggleChangeContactInfoDialog(
                                    this.state.selectedOrder[0]
                                      .shippingAddresses.id,
                                    this.state.selectedOrder[0]
                                      .shippingAddresses.customerName,
                                    this.state.selectedOrder[0]
                                      .shippingAddresses.mobileNo,
                                    this.state.selectedOrder[0]
                                      .shippingAddresses.address1,
                                    this.state.selectedOrder[0]
                                      .shippingAddresses.address2
                                  );
                                }}
                              />
                            </Button>
                          </div>
                        }
                      />
                      <Divider className={classes.itemCardTitleDivider} />
                      <CardContent>
                        <Grid container spacing={2}>
                          <Grid item xs={12}>
                            <div style={{ width: "100%" }}>
                              <List>
                                <ListItem>
                                  <div className={classes.listItemContainer}>
                                    <Typography
                                      className={classes.listItemKey}
                                      display="inline"
                                      style={{ width: "25%" }}
                                    >
                                      Name
                                    </Typography>
                                    <Typography
                                      style={{ textAlign: "left" }}
                                      className={classes.listItemKey}
                                    >
                                      {this.state.selectedOrder.length > 0
                                        ? this.state.selectedOrder[0]
                                          .shippingAddresses.customerName
                                        : ""}
                                    </Typography>
                                  </div>
                                </ListItem>
                                <ListItem>
                                  <div className={classes.listItemContainer}>
                                    <Typography
                                      className={classes.listItemKey}
                                      display="inline"
                                      style={{ width: "25%" }}
                                    >
                                      Address
                                    </Typography>
                                    <Typography
                                      style={{ textAlign: "left" }}
                                      className={classes.listItemKey}
                                    >
                                      {this.state.selectedOrder.length > 0
                                        ? this.state.selectedOrder[0]
                                          .shippingAddresses.completeAddress
                                        : ""}
                                    </Typography>
                                  </div>
                                </ListItem>
                                {/* <ListItem>
                                  <div className={classes.listItemContainer}>
                                    <Typography
                                      className={classes.listItemKey}
                                      display="inline"
                                      style={{ width: "25%" }}
                                    >
                                      Address 2
                                    </Typography>
                                    <Typography
                                      style={{ textAlign: "left" }}
                                      className={classes.listItemKey}
                                    >
                                      {this.state.selectedOrder.length > 0
                                        ? this.state.selectedOrder[0]
                                            .shippingAddresses.address2
                                        : ""}
                                    </Typography>
                                  </div>
                                </ListItem> */}
                                <ListItem>
                                  <div className={classes.listItemContainer}>
                                    <Typography
                                      className={classes.listItemKey}
                                      display="inline"
                                      style={{ width: "25%" }}
                                    >
                                      Mobile
                                    </Typography>
                                    <Typography
                                      style={{ textAlign: "left" }}
                                      className={classes.listItemKey}
                                    >
                                      {this.state.selectedOrder.length > 0
                                        ? this.state.selectedOrder[0]
                                          .shippingAddresses.mobileNo
                                        : ""}
                                    </Typography>
                                  </div>
                                </ListItem>
                                <ListItem>
                                  <div className={classes.listItemContainer}>
                                    <Typography
                                      className={classes.listItemKey}
                                      display="inline"
                                      style={{ width: "25%" }}
                                    >
                                      Payment Method
                                    </Typography>
                                    <Typography
                                      style={{ textAlign: "left" }}
                                      className={classes.listItemKey}
                                    >
                                      {this.state.selectedOrder.length > 0
                                        ? this.state.selectedOrder[0]
                                          .shippingAddresses.paymentMethod
                                        : ""}
                                    </Typography>
                                  </div>
                                </ListItem>


                              </List>
                            </div>
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                    {this.state.selectedOrder[0].isDisputed == 1 && (
                      <Card key={3} className={classes.itemCard}>
                        <CardHeader
                          style={{
                            backgroundColor: "#d9d8d8",

                            padding: "10px 16px",
                          }}
                          title={
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                width: "100%",
                              }}
                            >
                              Disputed Order Items
                            </div>
                          }
                        />
                        <Divider className={classes.itemCardTitleDivider} />
                        <CardContent>
                          <Grid container spacing={2}>
                            <Grid item xs={12}>
                              {this.props.values.salesDataLoading ? (
                                <div className={classes.circularProgressStyle}>
                                  <CircularProgress />
                                </div>
                              ) : (
                                <div style={{ width: "100%" }}>
                                  <List disablePadding>
                                    {!IsEmpty(
                                      this.state.selectedOrder[0].suggestions
                                    ) &&
                                      this.state.selectedOrder[0].suggestions.map(
                                        (sale, index) => {
                                          return (
                                            <>
                                              <Fragment key={sale}>
                                                {index == 0 && (
                                                  <ListItem>
                                                    <div
                                                      className={
                                                        classes.listItemContainer
                                                      }
                                                    >
                                                      <Typography
                                                        className={
                                                          classes.listItemKey
                                                        }
                                                        style={{ width: "10%" }}
                                                      >
                                                        Srn#
                                                      </Typography>

                                                      <Typography
                                                        className={
                                                          classes.listItemKey
                                                        }
                                                        style={{ width: "50%" }}
                                                      >
                                                        Product
                                                      </Typography>

                                                      <Typography
                                                        className={
                                                          classes.listItemKey
                                                        }
                                                        style={{ width: "40%" }}
                                                      >
                                                        Remarks
                                                      </Typography>
                                                    </div>
                                                  </ListItem>
                                                )}
                                                <Divider />
                                                <ListItem>
                                                  <div
                                                    className={
                                                      classes.listItemContainer
                                                    }
                                                  >
                                                    <Typography
                                                      className={
                                                        classes.listItemKey
                                                      }
                                                      style={{ width: "10%" }}
                                                    >
                                                      {index + 1}
                                                    </Typography>
                                                    <Typography
                                                      className={
                                                        classes.listItemKey
                                                      }
                                                      style={{ width: "50%" }}
                                                    >
                                                      {sale.productName}
                                                    </Typography>

                                                    <Typography
                                                      className={
                                                        classes.listItemKey
                                                      }
                                                      style={{
                                                        width: "40%",
                                                        color: "red",
                                                      }}
                                                    >
                                                      {sale.remarks}
                                                    </Typography>
                                                  </div>
                                                </ListItem>
                                              </Fragment>

                                              {sale.supervisorRemarks.map(
                                                (addonItem) => {
                                                  return (
                                                    <Fragment key={addonItem}>
                                                      <ListItem>
                                                        <div
                                                          className={
                                                            classes.listItemContainer
                                                          }
                                                        >
                                                          <Typography
                                                            className={
                                                              classes.listItemKey
                                                            }
                                                            style={{
                                                              width: "20%",
                                                            }}
                                                          >
                                                            Supervisor
                                                            Suggestion:
                                                          </Typography>
                                                          <Typography
                                                            className={
                                                              classes.listAddonItemKey
                                                            }
                                                            style={{
                                                              width: "50%",
                                                              color: "green",
                                                              fontSize: 14,
                                                              fontWeight: 600,
                                                            }}
                                                          >
                                                            {
                                                              addonItem.suggestion
                                                            }
                                                          </Typography>
                                                        </div>
                                                      </ListItem>
                                                    </Fragment>
                                                  );
                                                }
                                              )}
                                            </>
                                          );
                                        }
                                      )}
                                  </List>
                                </div>
                              )}
                            </Grid>
                          </Grid>
                        </CardContent>
                      </Card>
                    )}
                    <Card key={4} className={classes.itemCard}>
                      <CardHeader
                        style={{
                          backgroundColor: "#d9d8d8",

                          padding: "10px 16px",
                        }}
                        title={
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              width: "100%",
                            }}
                          >
                            Products Detaill

                          </div>
                        }
                      />
                      <Divider className={classes.itemCardTitleDivider} />
                      <CardContent>
                        <Grid container spacing={2}>
                          <Grid item xs={12}>
                            {this.props.values.salesDataLoading ? (
                              <div className={classes.circularProgressStyle}>
                                <CircularProgress />
                              </div>
                            ) : (
                              <div style={{ width: "100%" }}>
                                <List disablePadding>
                                  {!IsEmpty(
                                    this.state.selectedOrder[0].products[0]
                                  ) &&
                                    this.state.selectedOrder[0].products[0].summary.map(
                                      (sale, index) => {
                                        return (
                                          <>
                                            <Fragment key={sale}>
                                              {index == 0 && (
                                                <ListItem>
                                                  <div
                                                    className={
                                                      classes.listItemContainer
                                                    }
                                                  >
                                                    <Typography
                                                      className={
                                                        classes.listItemKey
                                                      }
                                                      style={{ width: "5%" }}
                                                    >
                                                      Srn#
                                                    </Typography>

                                                    <Typography
                                                      className={
                                                        classes.listItemKey
                                                      }
                                                      style={{ width: "30%" }}
                                                    >
                                                      Product
                                                    </Typography>

                                                    <Typography
                                                      className={
                                                        classes.listItemKey
                                                      }
                                                      style={{
                                                        width: "20%",
                                                        textAlign: "center",
                                                      }}
                                                    >
                                                      Quantity
                                                    </Typography>

                                                    <Typography
                                                      className={
                                                        classes.listItemKey
                                                      }
                                                      style={{ width: "10%" }}
                                                    >
                                                      Gross Amount
                                                    </Typography>
                                                    <Typography
                                                      className={
                                                        classes.listItemKey
                                                      }
                                                      style={{ width: "10%" }}
                                                    >
                                                      Discount Amount
                                                    </Typography>
                                                    <Typography
                                                      className={
                                                        classes.listItemKey
                                                      }
                                                      style={{ width: "10%" }}
                                                    >
                                                      Net Amount
                                                    </Typography>
                                                    <Typography
                                                      className={
                                                        classes.listItemKey
                                                      }
                                                      style={{
                                                        width: "15%",
                                                        textAlign: "center",
                                                      }}
                                                    >
                                                      Action
                                                    </Typography>

                                                  </div>
                                                </ListItem>
                                              )}
                                              <Divider />
                                              <ListItem>
                                                <div
                                                  className={
                                                    classes.listItemContainer
                                                  }
                                                >
                                                  <Typography
                                                    className={
                                                      sale.statusId == 2
                                                        ? classes.listItemKey
                                                        : classes.listItemRejectedKey
                                                    }
                                                    style={{ width: "5%" }}
                                                  >
                                                    {index + 1}
                                                  </Typography>
                                                  <Typography
                                                    className={
                                                      sale.statusId == 2
                                                        ? classes.listItemKey
                                                        : classes.listItemRejectedKey
                                                    }
                                                    style={{ width: "30%" }}
                                                  >
                                                    <div>
                                                      <div>
                                                        {sale.productName}
                                                      </div>
                                                      {sale.isBundleProduct ==
                                                        1 &&
                                                        sale.bundleProductsLabelsList &&
                                                        !IsEmpty(
                                                          sale.bundleProductsLabelsList
                                                        ) && (
                                                          <ul>
                                                            {sale.bundleProductsLabelsList.map(
                                                              (
                                                                bundleProduct
                                                              ) => {
                                                                return (
                                                                  <li
                                                                    key={
                                                                      bundleProduct
                                                                    }
                                                                  >
                                                                    {
                                                                      bundleProduct
                                                                    }
                                                                  </li>
                                                                );
                                                              }
                                                            )}
                                                          </ul>
                                                        )}
                                                    </div>
                                                  </Typography>

                                                  <Typography
                                                    className={
                                                      sale.statusId == 2
                                                        ? classes.listItemKey
                                                        : classes.listItemRejectedKey
                                                    }
                                                    style={{
                                                      display: "flex",
                                                      width: "20%",
                                                      justifyContent:
                                                        "space-evenly",
                                                    }}
                                                  >
                                                    {sale.quantity}
                                                    {this.state.selectedOrder[0]
                                                      .isDisputed == 1 ||
                                                      sale.isQuantityUpdated ==
                                                      1 ? (
                                                      <div
                                                        style={{
                                                          width: "24px",
                                                          height: "24px",
                                                        }}
                                                      ></div>
                                                    ) : (
                                                      <>
                                                        <Edit
                                                          disabled={
                                                            sale.statusId == 2
                                                              ? "false"
                                                              : "true"
                                                          }
                                                          fontSize="small"
                                                          onClick={() => {
                                                            if (
                                                              sale.statusId == 2
                                                            ) {
                                                              this.props.toggleChangeItemQuantityDialog(
                                                                sale
                                                              );
                                                            }
                                                          }}
                                                        />
                                                      </>
                                                    )}
                                                  </Typography>

                                                  <Typography
                                                    className={
                                                      sale.statusId == 2
                                                        ? classes.listItemKey
                                                        : classes.listItemRejectedKey
                                                    }
                                                    style={{
                                                      width: "10%",
                                                      textDecoration:
                                                        sale.statusId == 3
                                                          ? "line-through"
                                                          : "unset",
                                                    }}
                                                  >
                                                    {sale.grossAmount}
                                                  </Typography>
                                                  <Typography
                                                    className={
                                                      sale.statusId == 2
                                                        ? classes.listItemKey
                                                        : classes.listItemRejectedKey
                                                    }
                                                    style={{
                                                      width: "10%",
                                                      textDecoration:
                                                        sale.statusId == 3
                                                          ? "line-through"
                                                          : "unset",
                                                    }}
                                                  >
                                                    {sale.discountAmount}
                                                  </Typography>
                                                  <Typography
                                                    className={
                                                      sale.statusId == 2
                                                        ? classes.listItemKey
                                                        : classes.listItemRejectedKey
                                                    }
                                                    style={{
                                                      width: "10%",
                                                      textDecoration:
                                                        sale.statusId == 3
                                                          ? "line-through"
                                                          : "unset",
                                                    }}
                                                  >
                                                    {sale.netAmount}
                                                  </Typography>

                                                  <>
                                                    {sale.isAddon == "0" && (
                                                      <>
                                                        {sale.statusId == 2 ? (
                                                          <div
                                                            style={{
                                                              width: "10%",
                                                              textAlign: "right",
                                                            }}
                                                          >
                                                            <ImageButton
                                                              imageSrc={checkMark}
                                                              altText="Confirm"
                                                              onClick={() =>
                                                                this.props.toggleChangeStatusDialog(
                                                                  1,
                                                                  sale.orderId,
                                                                  sale.id,
                                                                  sale.productName
                                                                )
                                                              }
                                                            />


                                                            <ImageButton
                                                              //  imageSrc={giftVoucher}
                                                              imageSrc={crossMark}
                                                              altText="Cancel"
                                                              onClick={() =>
                                                                this.props.toggleChangeStatusDialog(
                                                                  2,
                                                                  sale.orderId,
                                                                  sale.id,
                                                                  sale.productName
                                                                )
                                                              }
                                                            />
                                                          </div>
                                                        ) : (
                                                          <div
                                                            style={{
                                                              width: "10%",
                                                              textAlign: "center",
                                                            }}
                                                          >
                                                            <Typography
                                                              className={
                                                                classes.listItemKey
                                                              }
                                                              style={{
                                                                width: "10%",
                                                                color: "red",
                                                                textAlign:
                                                                  "center",
                                                              }}
                                                            >
                                                              Rejected
                                                            </Typography>
                                                          </div>
                                                        )}
                                                      </>
                                                    )}
                                                  </>

                                                </div>
                                              </ListItem>
                                            </Fragment>

                                            {sale.addons.map((addonItem) => {
                                              return (
                                                <Fragment key={addonItem}>
                                                  <ListItem>
                                                    <div
                                                      className={
                                                        classes.listItemContainer
                                                      }
                                                    >
                                                      <Typography
                                                        className={
                                                          sale.statusId == 2
                                                            ? classes.listAddonItemKey
                                                            : classes.listAddonItemRejectedKey
                                                        }
                                                        style={{
                                                          width: "5%",
                                                        }}
                                                      ></Typography>
                                                      <Typography
                                                        className={
                                                          sale.statusId == 2
                                                            ? classes.listAddonItemKey
                                                            : classes.listAddonItemRejectedKey
                                                        }
                                                        style={{
                                                          width: "30%",
                                                        }}
                                                      >
                                                        {addonItem.productName}
                                                      </Typography>

                                                      <Typography
                                                        className={
                                                          sale.statusId == 2
                                                            ? classes.listAddonItemKey
                                                            : classes.listAddonItemRejectedKey
                                                        }
                                                        style={{
                                                          display: "flex",
                                                          width: "20%",
                                                          justifyContent:
                                                            "space-evenly",
                                                        }}
                                                      >
                                                        {addonItem.quantity}
                                                        <div
                                                          style={{
                                                            width: "24px",
                                                            height: "24px",
                                                          }}
                                                        ></div>
                                                      </Typography>

                                                      <Typography
                                                        className={
                                                          sale.statusId == 2
                                                            ? classes.listAddonItemKey
                                                            : classes.listAddonItemRejectedKey
                                                        }
                                                        style={{
                                                          width: "10%",
                                                          textDecoration:
                                                            sale.statusId == 3
                                                              ? "line-through"
                                                              : "unset",
                                                        }}
                                                      >
                                                        {addonItem.grossAmount}
                                                      </Typography>
                                                      <Typography
                                                        className={
                                                          sale.statusId == 2
                                                            ? classes.listAddonItemKey
                                                            : classes.listAddonItemRejectedKey
                                                        }
                                                        style={{
                                                          width: "10%",
                                                          textDecoration:
                                                            sale.statusId == 3
                                                              ? "line-through"
                                                              : "unset",
                                                        }}
                                                      >
                                                        {
                                                          addonItem.discountAmount
                                                        }
                                                      </Typography>
                                                      <Typography
                                                        className={
                                                          sale.statusId == 2
                                                            ? classes.listAddonItemKey
                                                            : classes.listAddonItemRejectedKey
                                                        }
                                                        style={{
                                                          width: "10%",
                                                          textDecoration:
                                                            sale.statusId == 3
                                                              ? "line-through"
                                                              : "unset",
                                                        }}
                                                      >
                                                        {addonItem.netAmount}
                                                      </Typography>
                                                    </div>
                                                  </ListItem>
                                                </Fragment>
                                              );
                                            })}

                                            {index ==
                                              this.state.selectedOrder[0]
                                                .products[0].summary.length -
                                              1 && (
                                                <>
                                                  <Divider />
                                                  <ListItem>
                                                    <div
                                                      className={
                                                        classes.listItemContainer
                                                      }
                                                    >
                                                      <Typography
                                                        className={
                                                          classes.listItemKey
                                                        }
                                                        style={{ width: "5%" }}
                                                      ></Typography>
                                                      <Typography
                                                        className={
                                                          classes.listItemKey
                                                        }
                                                        style={{ width: "50%" }}
                                                      >
                                                        Total Amount
                                                      </Typography>
                                                      <Typography
                                                        className={
                                                          classes.listItemKey
                                                        }
                                                        style={{ width: "10%" }}
                                                      >
                                                        {
                                                          this.state
                                                            .selectedOrder[0]
                                                            .products[index]
                                                            .totalGrossAmount
                                                        }
                                                      </Typography>
                                                      <Typography
                                                        className={
                                                          classes.listItemKey
                                                        }
                                                        style={{ width: "10%" }}
                                                      >
                                                        {
                                                          this.state
                                                            .selectedOrder[0]
                                                            .products[index]
                                                            .totalDiscountAmount
                                                        }
                                                      </Typography>
                                                      <Typography
                                                        className={
                                                          classes.listItemKey
                                                        }
                                                        style={{ width: "10%" }}
                                                      >
                                                        {
                                                          this.state
                                                            .selectedOrder[0]
                                                            .products[index]
                                                            .totalDiscountedGrossAmount
                                                        }
                                                      </Typography>
                                                      <Typography
                                                        className={
                                                          classes.listItemKey
                                                        }
                                                        style={{ width: "12%" }}
                                                      ></Typography>
                                                    </div>
                                                  </ListItem>
                                                  {this.state.selectedOrder[0]
                                                    .products[index]
                                                    .isVoucherApplied != 0 && (
                                                      <ListItem>
                                                        <div
                                                          className={
                                                            classes.listItemContainer
                                                          }
                                                        >
                                                          <Typography
                                                            className={
                                                              classes.listItemKey
                                                            }
                                                            style={{ width: "5%" }}
                                                          ></Typography>
                                                          <Typography
                                                            className={
                                                              classes.listItemKey
                                                            }
                                                            style={{ width: "70%" }}
                                                          >
                                                            Voucher Discount
                                                          </Typography>
                                                          <Typography
                                                            className={
                                                              classes.listItemKey
                                                            }
                                                            style={{ width: "10%" }}
                                                          >
                                                            {
                                                              this.state
                                                                .selectedOrder[0]
                                                                .products[index]
                                                                .voucherAmountLabel
                                                            }
                                                          </Typography>
                                                          <Typography
                                                            className={
                                                              classes.listItemKey
                                                            }
                                                            style={{ width: "12%" }}
                                                          ></Typography>
                                                        </div>
                                                      </ListItem>
                                                    )}
                                                  <ListItem>
                                                    <div
                                                      className={
                                                        classes.listItemContainer
                                                      }
                                                    >
                                                      <Typography
                                                        className={
                                                          classes.listItemKey
                                                        }
                                                        style={{ width: "5%" }}
                                                      ></Typography>
                                                      <Typography
                                                        className={
                                                          classes.listItemKey
                                                        }
                                                        style={{ width: "70%" }}
                                                      >
                                                        {
                                                          this.state
                                                            .selectedOrder[0]
                                                            .gstLabel
                                                        }
                                                      </Typography>
                                                      <Typography
                                                        className={
                                                          classes.listItemKey
                                                        }
                                                        style={{ width: "10%" }}
                                                      >
                                                        {
                                                          this.state
                                                            .selectedOrder[0]
                                                            .products[index]
                                                            .gstAmount
                                                        }
                                                      </Typography>
                                                      <Typography
                                                        className={
                                                          classes.listItemKey
                                                        }
                                                        style={{ width: "12%" }}
                                                      ></Typography>
                                                    </div>
                                                  </ListItem>
                                                  {this.state.selectedOrder[0]
                                                    .products[index]
                                                    .isReOrderWithoutAmount ==
                                                    1 && (
                                                      <ListItem>
                                                        <div
                                                          className={
                                                            classes.listItemContainer
                                                          }
                                                        >
                                                          <Typography
                                                            className={
                                                              classes.listItemKey
                                                            }
                                                            style={{ width: "5%" }}
                                                          ></Typography>
                                                          <Typography
                                                            className={
                                                              classes.listItemKey
                                                            }
                                                            style={{ width: "70%" }}
                                                          >
                                                            Sales Return
                                                          </Typography>
                                                          <Typography
                                                            className={
                                                              classes.listItemKey
                                                            }
                                                            style={{ width: "10%" }}
                                                          >
                                                            {
                                                              this.state
                                                                .selectedOrder[0]
                                                                .products[index]
                                                                .salesReturn
                                                            }
                                                          </Typography>
                                                          <Typography
                                                            className={
                                                              classes.listItemKey
                                                            }
                                                            style={{ width: "12%" }}
                                                          ></Typography>
                                                        </div>
                                                      </ListItem>
                                                    )}
                                                  {this.state.selectedOrder[0]
                                                    .products[index]
                                                    .isDeliveryChargesWavedOff !=
                                                    1 && (
                                                      <ListItem>
                                                        <div
                                                          className={
                                                            classes.listItemContainer
                                                          }
                                                        >
                                                          <Typography
                                                            className={
                                                              classes.listItemKey
                                                            }
                                                            style={{ width: "5%" }}
                                                          ></Typography>
                                                          <Typography
                                                            className={
                                                              classes.listItemKey
                                                            }
                                                            style={{ width: "70%" }}
                                                          >
                                                            Delivery Charges
                                                          </Typography>
                                                          <Typography
                                                            className={
                                                              classes.listItemKey
                                                            }
                                                            style={{ width: "10%" }}
                                                          >
                                                            {
                                                              this.state
                                                                .selectedOrder[0]
                                                                .products[index]
                                                                .deliveryCharges
                                                            }
                                                          </Typography>
                                                          <Typography
                                                            className={
                                                              classes.listItemKey
                                                            }
                                                            style={{ width: "12%" }}
                                                          ></Typography>
                                                        </div>
                                                      </ListItem>
                                                    )}
                                                  <ListItem>
                                                    <div
                                                      className={
                                                        classes.listItemContainer
                                                      }
                                                    >
                                                      <Typography
                                                        className={
                                                          classes.listItemKey
                                                        }
                                                        style={{ width: "5%" }}
                                                      ></Typography>
                                                      <Typography
                                                        className={
                                                          classes.listItemKey
                                                        }
                                                        style={{ width: "70%" }}
                                                      >
                                                        Total Net Amount
                                                      </Typography>
                                                      <Typography
                                                        className={
                                                          classes.listItemKey
                                                        }
                                                        style={{ width: "10%" }}
                                                      >
                                                        {
                                                          this.state
                                                            .selectedOrder[0]
                                                            .products[index]
                                                            .totalNetAmount
                                                        }
                                                      </Typography>
                                                      <Typography
                                                        className={
                                                          classes.listItemKey
                                                        }
                                                        style={{ width: "12%" }}
                                                      ></Typography>
                                                    </div>
                                                  </ListItem>
                                                </>
                                              )}
                                          </>
                                        );
                                      }
                                    )}
                                </List>
                              </div>
                            )}
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  </Fragment>
                )}
              </Fragment>
            )}
          </CardContent>
        </Card>
      </React.Fragment>
    );
  }
}

SalesTab.propTypes = {
  classes: PropTypes.object.isRequired,
  values: PropTypes.object,
  onConfirmClick: PropTypes.func,
  toggleChangeStatusDialog: PropTypes.func,
};

SalesTab.defaultProps = {
  values: {},
  onConfirmClick: (fn) => fn,
  toggleChangeStatusDialog: (fn) => fn,
};

export default withStyles(useStyles)(SalesTab);
